import React, { forwardRef, Ref } from 'react';
import { FormTextarea } from '@spotify-internal/encore-web';
import { FieldController } from 'client/shared/FieldController';
import { FieldTextAreaProps, ControlledFieldTextAreaProps } from './types';
import { FieldBottomSection } from '../FieldBottomSection';

export const FieldTextArea = forwardRef(
  (
    {
      name,
      maxLength,
      error,
      isShowingError = !!error,
      containerClassName,
      rows = 12,
      showCharacterCount = true,
      value,
      'aria-describedby': ariaDescribedBy = `${name}Error`,
      ...rest
    }: FieldTextAreaProps,
    ref: Ref<HTMLTextAreaElement>
  ) => {
    return (
      <div className={containerClassName}>
        <FormTextarea
          style={{ resize: 'none' }}
          ref={ref}
          {...rest}
          value={value}
          error={isShowingError}
          rows={rows}
          name={name}
          id={name}
          data-cy={name}
          maxLength={maxLength}
          aria-describedby={ariaDescribedBy}
        />
        <FieldBottomSection
          errorContainerId={ariaDescribedBy}
          isShowingError={isShowingError}
          showCharacterCount={showCharacterCount}
          maxCharacterLength={maxLength}
          value={value}
          error={error}
        />
      </div>
    );
  }
);

export const ControlledFieldTextArea = (
  props: ControlledFieldTextAreaProps
) => (
  <FieldController<FieldTextAreaProps, HTMLTextAreaElement>
    {...props}
    as={FieldTextArea}
  />
);
